import { useContext } from 'react';
import { PageContentStateContext } from '@src/contexts/wysiwyg/page_content';
import { isTextBox } from '@src/utils/wysiwyg_editor/data';

const DEFAULT_TEXT_BOX_BACKGROUND_COLOR = '#ffffff';

function useSelectedTextBoxBackgroundColor(): string {
  const { selectedPageContentItem } = useContext(PageContentStateContext);

  if (!isTextBox(selectedPageContentItem)) return DEFAULT_TEXT_BOX_BACKGROUND_COLOR;

  return selectedPageContentItem?.backgroundColor || DEFAULT_TEXT_BOX_BACKGROUND_COLOR;
}

export default useSelectedTextBoxBackgroundColor;
